/**
 * Print styles + verdict color map for the PDF report.
 *
 * Verdict colors are derived from `--rt-*` design tokens at render time
 * (see `dom.ts#resolveTokenColors`) so the PDF auto-restyles when the
 * design system changes — no hardcoded hexes here.
 */

export const REPORT_FONT_FAMILY =
  'Carlito, "Helvetica Neue", "Liberation Sans", Arial, sans-serif';

/** A4, generous margins, color preservation. */
export const PRINT_STYLE = `
@page {
  size: A4 portrait;
  margin: 0.75in 0.75in 0.75in 0.75in;
}
html, body {
  background: #FFFFFF !important;
  color: #0F1115;
  font-family: ${REPORT_FONT_FAMILY};
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.report-page { max-width: 1080px; margin: 0 auto; padding: 32px 16px; }
.report-h1 { font-family: "Source Serif 4", Georgia, serif; font-weight: 900; font-size: 28px; letter-spacing: -0.025em; margin: 0 0 8px; color: #094074; }
.report-meta { font-size: 12px; color: #6A6F7C; margin: 0 0 24px; }
.report-summary { display: flex; flex-wrap: wrap; gap: 12px; margin: 0 0 24px; font-family: 'JetBrains Mono', monospace; font-size: 11px; }
.report-summary span { padding: 2px 8px; border-radius: 2px; }
.report-arg { margin: 24px 0; page-break-inside: auto; break-inside: auto; }
.report-arg-head { font-family: 'JetBrains Mono', monospace; font-size: 11px; color: #6A6F7C; text-transform: uppercase; letter-spacing: 0.06em; margin: 0 0 8px; }
.report-arg-summary { font-size: 13px; line-height: 1.5; color: #1C1F26; margin: 0 0 12px; padding: 12px 14px; background: #F1F2F4; border-left: 3px solid #094074; }
.report-card { margin: 12px 0; padding: 12px 14px; border: 1px solid rgba(15,17,21,0.12); border-radius: 4px; box-decoration-break: clone; }
.report-card-head { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; margin-bottom: 4px; font-size: 11px; color: #6A6F7C; }
.report-card-tag { font-weight: 700; font-size: 14px; color: #0F1115; font-family: ${REPORT_FONT_FAMILY}; }
.report-card-cite { font-size: 12px; color: #6A6F7C; margin: 2px 0 6px; font-family: ${REPORT_FONT_FAMILY}; }
.report-card-body { font-size: 12.5px; line-height: 1.55; font-family: ${REPORT_FONT_FAMILY}; }
.report-card-body .hl { background: rgba(255, 235, 59, 0.45); }
.report-card-reason { margin-top: 8px; padding: 8px 12px; font-size: 12px; line-height: 1.5; border-left: 2px solid currentColor; }
@media print {
  .report-card { page-break-inside: auto; break-inside: auto; }
  .report-arg-head, .report-card-head { page-break-after: avoid; break-after: avoid; }
}
`;
